// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkrecord{display:flex;flex-direction:row;margin:0 0 0 20px}.gradegrid{display:grid;grid-template-columns:1fr 5fr;text-align:left}.updatebutton{height:30px;width:150px;border-radius:5px;padding:3px;margin:0 0 10px 0}.checklabel{margin:5px}.routeselect{height:25px;width:100px}", ""]);
// Exports
module.exports = exports;
